var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "b-doctor-details__item b-box b-box_shadow b-box_padding_small text--text",
      attrs: { id: "section-practice", "data-qa": "section_practice" },
    },
    [
      _c(_setup.IntroductionContent, { staticClass: "mb-6" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "section-practice__content d-flex ga-6 align-start" },
        [
          _c(
            "div",
            { staticClass: "section-practice__column" },
            [_c(_setup.DiseasesStatistics)],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section-practice__column d-flex flex-column ga-4" },
            [
              _c(_setup.PatientStatistics),
              _vm._v(" "),
              _c(_setup.LpuListPartners),
              _vm._v(" "),
              _c(_setup.PracticeUpdatedDate),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }